import type { SVGProps } from 'react';

const SvgTimeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V11.75C11.25 12.1434 11.4352 12.5139 11.75 12.75L15.5498 15.5996C15.8811 15.8481 16.351 15.7813 16.5996 15.4502C16.8481 15.1189 16.7813 14.649 16.4502 14.4004L12.75 11.624V7C12.75 6.58579 12.4142 6.25 12 6.25Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgTimeFilled;
